import React, { useEffect } from 'react';
import { get } from '../../../Utils/Crypto';
import { useSelector } from 'react-redux';



const Migration = () => {
  
    let config = useSelector(state=>state.auth.config);

    let url = '';
    if(window.location.href.includes('localhost')){
      url = `http://localhost:3001/nroute?grant_type=redirect&access_token=${get('token')}&name=${config.name}&refresh_token=${get('refresh_token')}&token_type=bearer}}`
    }else{
      url = `https://corporate.dice.tech/nroute?grant_type=redirect&access_token=${get('token')}&name=${config.name}&refresh_token=${get('refresh_token')}&token_type=bearer}}`
    }
    useEffect(()=>{
      setTimeout(()=>{
        window.open(url)
      },5000)
    },[url])

    return(
    <div style={{display: 'flex',justifyContent: 'center',alignItems: 'center',height: '100vh'}}>
      <div style={{'background-color': '#3498db','border-radius': '5px','color': '#fff','padding': '20px','text-align': 'center','box-shadow': '0 0 10px rgba(0, 0, 0, 0.2)','max-width': '450px'}}>
        <p>
          <span role="img" aria-label="Rocket Emoji">🚀</span> 
          Exciting news! We have upgraded our finance UI.  <br></br>
          Redirecting you to the new link. Please bookmark it for future login.

          <p   style={{
            textDecoration:'underline',
            cursor:'pointer'
          }} onClick={()=>{
            window.open(url)
          }}>Check it out now</p>
        </p>
      </div>
    </div>
    )
}

export default Migration;